/**
 * usePledgesState — Local state for the pledges management UI.
 */
import { useState } from 'react';
import { RewardPledge } from '@/types/rewards';
import { PledgeState } from './types';

export function usePledgesState(): PledgeState {
  const [sentPledges, setSentPledges] = useState<RewardPledge[]>([]);
  const [receivedPledges, setReceivedPledges] = useState<RewardPledge[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  return {
    sentPledges,
    receivedPledges,
    loading,
    error,
    setSentPledges,
    setReceivedPledges,
    setLoading,
    setError
  };
}
